<template>
  <div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>

<div class="columns is-gapless" style="margin-bottom:0em;">
    <!-- <div class="column is-10 has-text-weight-bold is-size-5 mt-1"></div> -->
    <div class="column has-text-centered is-3 has-text-right has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
      <button v-print="'#printME'"  class="button has-text-light is-fullwidth has-background-grey-dark"><span class="icon is-small"> <i class="fas fa-print"></i> </span>&nbsp;&nbsp;&nbsp;&nbsp;{{group_code}}</button>
  </div>
</div>


<div id="printME">
<div class="table-container">
  <table class="table is-narrow is-bordered">

  <thead>
    <tr class="is-size-7">
      <th><abbr title="nom">NOM</abbr></th>
      <th>AVG</th>
        <th class="has-text-info-dark" v-for="(data,index) in data_courses"  :key="index">{{data.courAbbrev}}</th>
    </tr>
  </thead>

  <tbody>
    <tr :class="return_style_average(data.avg)" v-for="(data,index) in data_students"  :key="index">
       <th>
<div class="columns is-gapless is-multiline">
    <div class="column is-12" style="margin-bottom:-.4em;">{{data.nom}}</div>
    <div class="column is-6 doFontSmallest">{{data.fnom}}</div>
    <div class="column is-6 has-text-right doFontSmallest">{{data.grp}}&nbsp;</div>
</div>


       </th>
       <th class="has-background-grey-light has-text-centered">{{data.avg}}</th>
       <th class="has-text-centered" v-for="index in data_courses.length" :key="index">
           {{return_note(data.student_ID, data_courses[index-1].group_ID )}}
           <!-- {{data.student_ID}}-{{data_courses[index-1].cour_ID}}  -->



       </th>

    </tr>
  </tbody>


  </table>
</div>
<!-- end table  -->
</div> <!-- PRINT  -->


  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'; 
// import jsMES from "@/assets/js/js_mes.js";
// import { French } from "flatpickr/dist/l10n/fr.js"

export default {
  name: 'rapport_summary',
  props: ['group_code'],

    data() {
        return {
            isLoading : false,
            data_master:[],
            data_courses:[],
            data_students:[],


    } }, // END DATA




    created() {
        this.summary_load()
    }, // END CREATED

    methods:{

return_note:function(sID, gID){
// RETURN VALUE FOR TABLE
var i = this.data_master.findIndex(obj => obj.student_ID == sID && obj.group_ID == gID)
    if (i>-1) {return this.data_master[i].cs_MARK}
    else {return ''} 
},

return_calculate_average:function(studID) {
    // var notes = 0 ; var count = 0 ;
    // var arrN = this.data_master.filter(data => data.student_ID == studID);
    // var notes = arrN.reduce((a, b) => a + (+b['cs_MARK'] || 0), 0);
    // return Math.round(notes/arrN.length)

    var arrFilter = this.data_master.filter(data => data.student_ID == studID);
    // var arrN = []
    var arrN = arrFilter.filter(function (el) {
    return el.cs_MARK != null;
    });

    var notes = arrN.reduce((a, b) => a + (+b['cs_MARK'] || 0), 0);
    return Math.round(notes/arrN.length)


},

return_style_average:function(avg) {
    if (avg < 60) {return 'has-background-danger-light'}
    else if (avg > 59 && avg < 66) {return 'has-background-light'}
    else if (avg > 84 && avg <= 94) {return 'has-background-success-light'}
    else if (avg >= 95) {return 'has-background-info has-text-white'}

},

summary_load:function() {
//   AVG(CAST(cs_MARK AS int)) AS studAvg,
var query = `SELECT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, 
 MyMEQ_STUDENT.student_lNAME,MyMEQ_STUDENT.student_fNAME, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_GROUP.group_ID,MyMEQ_GROUP.group_SESS, 
 MyMEQ_GROUP.group_ANN, MyMEQ_GROUP.group_AVG, MyMEQ_COUR.cour_CODE, 
 SUBSTRING(cour_CODE,5,3) AS courAbbrev,
 MyMEQ_COUR.cour_ID
FROM MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
WHERE (MyMEQ_GROUP.group_CODE = '` + this.group_code + `')
ORDER BY group_datSTART ASC`

console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    this.data_master = res.data

// DISTINCT COURSeS 
const map = new Map();
for (const item of this.data_master) {
    if(!map.has(item.group_ID)){
        map.set(item.group_ID, true); 
        this.data_courses.push({
            group_ID:item.group_ID,
            cour_ID: item.cour_ID,
            cour_CODE: item.cour_CODE,
            courAbbrev:item.courAbbrev
        });
    }
}
// DISTINCT STUDENTS 
const map2 = new Map();
for (const item of this.data_master) {
    if(!map2.has(item.student_ID)){
        map2.set(item.student_ID, true); 
        this.data_students.push({
            student_ID: item.student_ID,
            nom: item.student_lNAME,
            fnom: item.student_fNAME,
            grp: item.student_GRPCODE,
            avg:this.return_calculate_average(item.student_ID)
        });
    }
}
this.data_students.sort((a,b) => (a.avg < b.avg) ? 1 : ((b.avg < a.avg) ? -1 : 0))

})

},





    }, // END METHODS




}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
